import React from 'react';
import { Modal, Button, Spinner, Toast, ToastContainer } from 'react-bootstrap';
import { useTreinamento } from '../../hooks/useTreinamento';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const TreinamentoObs = () => {
    
    const {
        nomeCliente,
        setNomeCliente,
        funcaoCliente,
        setFuncaoCliente,
        contatoCliente,
        setContatoCliente,
        duvidasCliente,
        setDuvidasCliente,
        feitoCliente,
        setFeitoCliente,
        anexos,
        setAnexos,
        proximoPasso,
        setProximoPasso,
        handleSubmit,
        navigate,
        mensagemFinal,
        handleSendToAdm,
        showModal,
        setShowModal,
        setShowToastError,
        setShowToastSuccess,
        showToastError,
        showToastSuccess,
        handleEnviarObs,
        isLoading,
        showToastCopiar,
        setShowToastCopiar,
        funcaoClienteOptions,
        labelBtnCopy,
        setLabelBtnCopy
    } = useTreinamento();

    return (
        <div className="container-data">
            <h1 className='h1treinamento'>Solicitação de Treinamento</h1>
            <form className='form-cancelamento'>
                <div className="form-group">
                    <label className='label-mensagem'>Quem solicitou:</label>
                    <textarea
                        value={nomeCliente}
                        onChange={(e) => setNomeCliente(e.target.value)}
                        placeholder="Nome do cliente"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Qual sua função:</label>
                    <Select
                        options={funcaoClienteOptions}
                        value={funcaoClienteOptions.find(option => option.value === funcaoCliente) || (funcaoCliente ? { value: funcaoCliente, label: funcaoCliente } : null)}
                        onChange={(selectedOption) => {
                            setFuncaoCliente(selectedOption ? selectedOption.value : '');
                        }}
                        isClearable
                        isSearchable
                        placeholder="Selecione ou digite sua função"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                textAlign: 'left' 
                            }),
                            control: (provided) => ({
                                ...provided,
                                display: 'flex',
                                textAlign: 'left'
                            })
                        }}
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Contato:</label>
                    <textarea
                        value={contatoCliente}
                        onChange={(e) => setContatoCliente(e.target.value)}
                        placeholder="Número do WhatsApp ou E-mail"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Principais dúvidas:</label>
                    <textarea
                        value={duvidasCliente}
                        onChange={(e) => {
                            setDuvidasCliente(e.target.value)
                            e.target.style.height = 'auto';
                            e.target.style.height = `${e.target.scrollHeight}px`
                        }}
                        placeholder="Descreva as dúvidas"
                        className="textarea auto-resize-textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>O que já foi feito:</label>
                    <textarea
                        value={feitoCliente}
                        onChange={(e) => {
                            setFeitoCliente(e.target.value)
                            e.target.style.height = 'auto';
                            e.target.style.height = `${e.target.scrollHeight}px`
                        }}
                        placeholder="Descreva como você já tentou ajudar o cliente"
                        className="textarea auto-resize-textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Anexos:</label>
                    <textarea
                        value={anexos}
                        onChange={(e) => setAnexos(e.target.value)}
                        placeholder="Link de print/áudio (não colocar link do chat)"
                        className="textarea"
                    />
                </div>
                <div className="form-group">
                    <label className='label-mensagem'>Próximo passo:</label>
                    <textarea
                        value={proximoPasso}
                        onChange={(e) => setProximoPasso(e.target.value)}
                        placeholder="Descreva o próximo passo"
                        className="textarea"
                    />
                </div>
            </form>
            <div className='options-gerar-mensagem'>
                <button onClick={() => navigate('/treinamento')} className="botaovoltar">
                    <FontAwesomeIcon icon={faArrowLeft} className='arrow-left-icon' />
                    Voltar
                </button>
                <button onClick={handleSubmit} className="botao-pesquisa">Gerar</button>
            </div>

            {mensagemFinal && (<>
                <div className='div-mensagem-cancelamento'>
                    <div className="mensagem-gerada">
                        <h2>Mensagem Gerada:</h2>
                        <pre className='mensagem-cancelamento'>{mensagemFinal}</pre>
                    </div> 
                </div>
            <div className='options-mensagem-cancelamento'>
                        <button className="post-button" onClick={handleSendToAdm}>Enviar ao ADM</button>
                    <button 
                        className="post-button" 
                        onClick={() => {
                        navigator.clipboard.writeText(mensagemFinal);
                        setShowToastCopiar(true);
                        setLabelBtnCopy('Copiado!');
                        setTimeout(() => {
                            setLabelBtnCopy('Copiar');
                        }, 3000);
                        }}
                    >
                        {labelBtnCopy}
                    </button>
                    </div>
                    </>
            )}


            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Enviar ao ADM</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>Mensagem:</h4>
                    <pre>{mensagemFinal}</pre>

                </Modal.Body>
                <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                    Fechar
                </Button>
                <Button variant="success" onClick={handleEnviarObs} disabled={isLoading}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : "Enviar"}
                </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer position="bottom-end" className="p-3">
                <Toast 
                    onClose={() => setShowToastSuccess(false)} 
                    show={showToastSuccess} 
                    delay={3000} 
                    autohide 
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Sucesso</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Observação enviada com sucesso!</Toast.Body>
                </Toast>

                <Toast 
                    onClose={() => setShowToastCopiar(false)} 
                    show={showToastCopiar} 
                    delay={3000} 
                    autohide 
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Sucesso</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Observação copiada com sucesso!</Toast.Body>
                </Toast>

                <Toast 
                    onClose={() => setShowToastError(false)} 
                    show={showToastError} 
                    delay={3000} 
                    autohide 
                    bg="danger"
                >
                    <Toast.Header>
                        <strong className="me-auto">Erro</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Erro ao enviar a observação.</Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};

export default TreinamentoObs;
